import { UAParser } from 'ua-parser-js';

export function bindStickyBar() {
    const { device } = UAParser(window.navigator.userAgent);
    if (device.type === 'mobile') {
        document.querySelector('.sticky-footer-bars').classList.add('sticky');
    }
}
